import './polyfills';
import { createRoot } from "react-dom/client";
import { App } from "./App";
import 'antd/dist/antd.css'; // Ant Design styles
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import { BrowserRouter } from "react-router-dom";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
